import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, InputGroup, Intent, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, IRelatorios, newEmpresa, newIRelatorios } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { formatCnpj, gerarPeriodos } from "../../utils";
import { RelatorioStore } from "../../stores/relatorio/RelatorioStore";
import { Pager } from "../utils/Pager";
import moment from "moment";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { DateRangePicker90 } from "../utils/DateRangePicker90";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { PagamentosMultiselect } from "../utils/PagamentosMultiselect";
import { toast } from "react-toastify";

@observer
export class IntegracoesChaveTokenPage extends React.Component<{}, {}> {

  obs = observable({
    selectEmpresa: newEmpresa() as IEmpresa,
    current_page: 1 as number,
    erros_relatorio: [] as any,
    relatorios: [] as any,
    selectedPeriodChaves: [] as any,
    selectedPeriodSolicitacao: [] as any,
    selectEmpresaSolicitacao: newEmpresa() as IEmpresa,
    chaves: [] as string[],
    date1: "" as string,
    date2: "" as string,
    tipo_integracao_busca: "dominio" as string,
    tipo_integracao_solicitacao: "dominio" as string,
    loading_tasks: false as boolean
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("Chaves e Tokens de Integração");

    const inicioMes = moment().startOf("month");
    const fimMes = moment().endOf("month");

    this.obs.selectedPeriodChaves = [inicioMes.toDate(), fimMes.toDate()];
    this.obs.date1 = inicioMes.format("YYYY-MM-DD");
    this.obs.date2 = fimMes.format("YYYY-MM-DD");

    RelatorioStore.handleTasksPagedChavesToken(1, "", this.obs.date1, this.obs.date2, "dominio");
  }

  /**
  * Altera a página atual da listagem de relatórios de chaves token.
  *
  * Este método atualiza o número da página atual no estado observado (`obs`)
  * e, em seguida, solicita ao `RelatorioStore` o carregamento dos dados
  * paginados referentes à nova página selecionada.
  *
  * A busca considera os filtros atualmente selecionados, como empresa,
  * período e tipo de integração.
  *
  * @param page - Número da página que será carregada.
  *
  * @returns Não possui retorno explícito. Aguarda a conclusão da busca
  *          paginada dos relatórios de chaves token.
  */

  async handleChangePage(page: number) {
    this.obs.current_page = page
    await RelatorioStore.handleTasksPagedChavesToken(page, this.obs.selectEmpresa.cnpj, this.obs.date1, this.obs.date2, this.obs.tipo_integracao_busca)
  }

  /**
  * Atualiza o período selecionado para a busca de relatórios de chaves token.
  *
  * Este método recebe o valor selecionado no componente de período,
  * armazena esse valor no estado observado (`obs.selectedPeriodChaves`)
  * e atualiza as datas inicial e final utilizadas nos filtros da busca.
  *
  * Quando o período informado contém pelo menos duas datas, elas são
  * formatadas para o padrão `YYYY-MM-DD` utilizando a biblioteca `moment`.
  *
  * Caso o período esteja vazio, incompleto ou inválido, os campos de data
  * inicial e final são limpos.
  *
  * @param val - Valor selecionado no componente de período.
  *              Espera-se um array contendo a data inicial na posição `0`
  *              e a data final na posição `1`.
  *
  * @returns Não possui retorno.
  */

  handlePeriodoChavesChange = (val: any) => {
    this.obs.selectedPeriodChaves = val;

    if (val && val.length >= 2) {
      this.obs.date1 = moment(val[0]).format("YYYY-MM-DD");
      this.obs.date2 = moment(val[1]).format("YYYY-MM-DD");
    } else {
      this.obs.date1 = "";
      this.obs.date2 = "";
    }
  };

  /**
  * Atualiza o período selecionado para solicitação de relatório.
  *
  * Este método recebe o valor selecionado no componente de período
  * e armazena essa informação no estado observado (`obs`), através
  * da propriedade `selectedPeriodSolicitacao`.
  *
  * Ele não realiza formatação de datas nem validação do período,
  * apenas mantém o valor selecionado disponível para uso posterior,
  * como na solicitação de relatórios.
  *
  * @param val - Valor selecionado no componente de período de solicitação.
  *              Pode representar uma data, um intervalo de datas ou outro
  *              formato definido pelo componente utilizado.
  *
  * @returns Não possui retorno.
  */

  handlePeriodoSolicitacaoChange = (val: any) => {
    this.obs.selectedPeriodSolicitacao = val;
  };

 /**
 * Fecha a tela/modal inicial de solicitação de relatório e limpa os dados preenchidos.
 *
 * Este método é responsável por resetar os estados utilizados na solicitação
 * de relatório de chaves token. Ao ser executado, ele fecha a interface inicial,
 * limpa a empresa selecionada, o período informado, o modelo, o tipo, as chaves
 * selecionadas e redefine o tipo de integração para o valor padrão.
 *
 * Normalmente é utilizado ao fechar um modal, cancelar uma solicitação
 * ou reiniciar o formulário para uma nova operação.
 *
 * @returns Não possui retorno.
 */

  onClose() {
    RelatorioStore.obs.open_initial = false
    this.obs.selectEmpresaSolicitacao = newEmpresa()
    this.obs.selectedPeriodSolicitacao = []
    RelatorioStore.obs.modelo = ""
    RelatorioStore.obs.tipo = ""
    RelatorioStore.obs.selectedEmpresa = newEmpresa()
    this.obs.chaves = []
    this.obs.tipo_integracao_solicitacao = "dominio"
  }

  /**
  * Trata e exibe os erros retornados em um relatório.
  *
  * Este método recebe uma string contendo erros separados por vírgula,
  * converte essa string em uma lista e formata cada erro em um objeto
  * com a propriedade `erros`.
  *
  * Após montar a lista de erros, ela é armazenada no estado observado
  * (`obs.erros_relatorio`) e o modal/tela de erros do relatório é aberto.
  *
  * @param error - String contendo os erros do relatório separados por vírgula.
  *
  * @returns Não possui retorno.
  */

  handleErrosRelatorio(error: string) {
    let list_erros = error.split(",")
    this.obs.erros_relatorio = list_erros?.map(x => {
      return { "erros": x }
    })
    RelatorioStore.obs.open_erros_relatorio = true
  }

  /**
  * Fecha a visualização de erros do relatório e limpa a lista de erros.
  *
  * Este método é responsável por fechar o modal ou tela onde os erros
  * do relatório são exibidos. Além disso, remove todos os erros armazenados
  * no estado observado (`obs.erros_relatorio`), garantindo que a lista esteja
  * vazia ao abrir novamente a visualização.
  *
  * @returns Não possui retorno.
  */

  onCloseErros() {
    RelatorioStore.obs.open_erros_relatorio = false
    this.obs.erros_relatorio = []
  }

  /**
  * Valida os dados preenchidos e solicita a geração de um relatório de chaves token.
  *
  * Este método é responsável por validar se uma empresa e um período foram
  * selecionados antes de solicitar o relatório. Caso alguma informação obrigatória
  * esteja ausente, uma mensagem de aviso é exibida ao usuário e a execução é
  * interrompida.
  *
  * Quando os dados são válidos, o método chama o `RelatorioStore` para solicitar
  * a geração do relatório de chaves token. Se a solicitação for concluída com
  * sucesso, a listagem de relatórios é recarregada utilizando o período do mês
  * atual e o tipo de integração selecionado na solicitação.
  *
  * Ao final da execução, a tela/modal de solicitação é fechado e os campos do
  * formulário são resetados através do método `onClose`.
  *
  * @returns Não possui retorno explícito.
  */

  handleSolicitar = async () => {
    if (this.obs.selectEmpresaSolicitacao.cnpj === "") {
      toast.warning("Selecione uma empresa!", {});
      return;
    }

    if (!this.obs.selectedPeriodSolicitacao || this.obs.selectedPeriodSolicitacao.length < 2 || !moment(this.obs.selectedPeriodSolicitacao[0]).isValid() || !moment(this.obs.selectedPeriodSolicitacao[1]).isValid()) {
      toast.warning("Selecione o período.", {});
      return;
    }

    let resp = await RelatorioStore.handleSolicitarRelatorioChavesToken(this.obs.selectEmpresaSolicitacao.cnpj, this.obs.selectedPeriodSolicitacao, this.obs.tipo_integracao_solicitacao, this.obs.chaves, this.obs.selectEmpresaSolicitacao.razao_social);

    if(resp) {

      const inicioMesAtual = moment().startOf("month");
      const fimMesAtual = moment().endOf("month");

      const date1 = inicioMesAtual.format("YYYY-MM-DD");
      const date2 = fimMesAtual.format("YYYY-MM-DD");

      await RelatorioStore.handleTasksPagedChavesToken(this.obs.current_page = 1, this.obs.selectEmpresa.cnpj, date1, date2, this.obs.tipo_integracao_busca = this.obs.tipo_integracao_solicitacao);

    }

    RelatorioStore.obs.open_initial = false
    this.onClose();

  };

  /**
  * Atualiza o tipo de integração utilizado na busca principal.
  *
  * Este método recebe o status selecionado pelo usuário e armazena esse valor
  * no estado observado (`obs.tipo_integracao_busca`). Esse campo é utilizado
  * como filtro para consultas ou listagens relacionadas aos relatórios de
  * chaves token.
  *
  * @param status - Tipo de integração selecionado para ser usado na busca.
  *
  * @returns Não possui retorno.
  */

  handleStatusChangePrincipal = (status: string) => {
    this.obs.tipo_integracao_busca = status;
  };

  /**
  * Atualiza o tipo de integração utilizado na solicitação de relatório.
  *
  * Este método recebe o status selecionado pelo usuário e armazena esse valor
  * no estado observado (`obs.tipo_integracao_solicitacao`). Esse campo é usado
  * posteriormente no momento da solicitação do relatório de chaves token.
  *
  * @param status - Tipo de integração selecionado para a solicitação.
  *
  * @returns Não possui retorno.
  */

  handleStatusChangeSolicitacao = (status: string) => {
    this.obs.tipo_integracao_solicitacao = status;
  };

  /**
  * Realiza a busca paginada dos relatórios de chaves token com base nos filtros informados.
  *
  * Este método valida se o período de busca foi preenchido corretamente.
  * Caso as datas inicial e final não estejam informadas, uma mensagem de aviso
  * é exibida ao usuário e a busca não é executada.
  *
  * Quando o período está válido, a página atual é redefinida para a primeira
  * página e o método chama o `RelatorioStore` para carregar os relatórios de
  * chaves token conforme os filtros selecionados: empresa, período e tipo de
  * integração.
  *
  * Após a busca, caso nenhum relatório seja encontrado, uma mensagem de aviso
  * é exibida ao usuário.
  *
  * @returns Não possui retorno explícito.
  */

  async handleBuscaTarefas() {

    if (!this.obs.date1 || this.obs.date1 == "Data inválida" || !this.obs.date2 || this.obs.date2 == "Data inválida") {
      toast.warning("Selecione o período.", {});
      return;
    }

    var data_inicial = this.obs.date1;
    var data_fim = this.obs.date2;

    this.obs.current_page = 1;

    await RelatorioStore.handleTasksPagedChavesToken(this.obs.current_page, this.obs.selectEmpresa.cnpj, data_inicial, data_fim, this.obs.tipo_integracao_busca);

    if (RelatorioStore.obs.length_tasks_relatorio === 0) {
      toast.warning("Nenhum relatório encontrado para os filtros informados.", {});
    }
  }

  render() {
    let items = RelatorioStore.obs.tasks_relatorio?.map(imp => {
      return (
        {
          id: imp._id,
          cnpj: imp.cnpj,
          razao_social: imp.razao_social,
          inserted_at: imp.inserted_at,
          date_start: imp.date_start,
          date_end: imp.date_end,
          status: imp.status,
          relatorio_id: imp.relatorio_id,
          error: imp.error,
          modelo: imp.modelo,
          tipo: imp.tipo,
          format: imp.format,
          integracao: imp.integracao
        }
      );
    });

    let empresaText = this.obs.selectEmpresa.cnpj
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let empresaTextSolicitacao = this.obs.selectEmpresaSolicitacao.cnpj
      ? `${this.obs.selectEmpresaSolicitacao.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresaSolicitacao.cnpj)})`
      : "Selecione uma empresa";

    function statusFormatter(cell, row) {

      return getTag(row.status, "relatorio");

    }

    function stringFormatter(cell, row) {
      return (cell)?.toUpperCase();
    };

    function fileFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2}
            onClick={() => RelatorioStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj, row.format)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    const errosFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 3}
            onClick={() => this.handleErrosRelatorio(row.error)}
          >
            <img src="/images/view.png" />
          </MDBBtn>
        </>
      );
    }

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const dateFormatterPeriodo = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY");
    };

    const cnpjFormatter = (cell, row) => {
      return formatCnpj(row.cnpj)
    };

    return (
      <>

        <MDBRow>
          <MDBCol md="3">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => {
                  this.obs.selectEmpresa = e
                }}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <FormGroup label="Período Solicitação" className="inputsPeriodoCalculos">
              <DateRangePicker90
                onChange={this.handlePeriodoChavesChange}
                value={this.obs.selectedPeriodChaves} />
            </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <FormGroup label="Tipo integração" style={{ width: "90%" }}>
              <HTMLSelect
                onChange={(e) => this.handleStatusChangePrincipal(e.target.value)}
                value={this.obs.tipo_integracao_busca}
              >
                <option value="dominio">Domínio</option>
                <option value="sci">SCI</option>
                <option value="questor">Questor</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol style={{ alignItems: "flex-end" }}>
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              style={{ marginTop: 25 }}
              onClick={() => this.handleBuscaTarefas()}
              loading={this.obs.loading_tasks}
            >
              Buscar

            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol xl="12" lg="12" md="12" sm="12" xs="12" className="btns-Drop">
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => RelatorioStore.obs.open_initial = true}
              style={{ float: "left" }}
            >
              Solicitar Relatório
            </MDBBtn>
          </MDBCol>
        </MDBRow>


        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={items}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data da Solicitação</TableHeaderColumn>
            <TableHeaderColumn dataFormat={stringFormatter} dataField="integracao" width="20%">Integração</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatterPeriodo} dataField="date_start" width="20%">Período Inicial</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatterPeriodo} dataField="date_end" width="20%">Período Final</TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={RelatorioStore.obs.length_tasks_relatorio}
            pageSize={15}
            onPageChange={page => this.handleChangePage(page)}
          />
        </div>

        <Dialog
          isOpen={RelatorioStore.obs.open_initial}
          onClose={() => RelatorioStore.obs.open_initial = false}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Solicitar Relatório</h2>
          <FormGroup
            label="Empresa"
            className="empresaSelect"
          >
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => {
                this.obs.selectEmpresaSolicitacao = e;
              }}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaTextSolicitacao}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </EmpresaSelect>

            <div style={{ display: "flex", alignItems: "flex-end", gap: 15 }}>
              <FormGroup label="Período consulta" className="inputsPeriodoCalculos" style={{ marginTop: 10, width: "50%" }}>
                <DateRangePicker30
                  onChange={this.handlePeriodoSolicitacaoChange}
                  value={this.obs.selectedPeriodSolicitacao}
                  disabled={false}
                />
              </FormGroup>

              <FormGroup label="Tipo integração" style={{ width: "50%" }}>
                <HTMLSelect
                  onChange={(e) => this.handleStatusChangeSolicitacao(e.target.value)}
                  value={this.obs.tipo_integracao_solicitacao}
                  style={{ width: "100%" }}
                >
                  <option value="dominio">Domínio</option>
                  <option value="sci">SCI</option>
                  <option value="questor">Questor</option>
                </HTMLSelect>
              </FormGroup>
            </div>

            <FormGroup label="Chaves(opcional)" className="inputsPeriodoCalculos" style={{ marginTop: 10, width: "100%" }}>
              <div style={{ marginBottom: 10, maxWidth: "500px" }}>
                <PagamentosMultiselect onChange={(selected) =>
                  this.obs.chaves = selected} value={this.obs.chaves} />
              </div>
              <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
                <b>Observação:</b> Nas chaves de NFS-e, inclua NFS antes da chave. Exemplo: NFS1234.
              </p>
            </FormGroup>

          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Solicitar" intent="primary" onClick={() => this.handleSolicitar()} />
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          isOpen={RelatorioStore.obs.open_erros_relatorio}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
        >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
            {this.obs.erros_relatorio.length ?
              <div className="errosSped">
                <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                </BootstrapTable>
              </div>
            :<></>}
          </MDBCol>
        </Alert>
        
        <LoadingModal open={RelatorioStore.obs.loading} onClose={() => RelatorioStore.obs.loading = false} title={"Baixando arquivo"} />
      </>
    )
  }
}

export default IntegracoesChaveTokenPage;
